import {
  focusVisiblePolyfill, onDocumentReady, onKeyUpEscape, pauseAllMedia, removeTrapFocus, trapFocus,
} from "../utils/dom";

import { debounce } from "../utils/performance";

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if (!summary.closest('.mega-menu')) {
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
  }

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) === 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || 'post';
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options.hideElement || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute('data-provinces');
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('.menu-drawer__close-button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    closeAnimation(this.mainDetailsToggle);

  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    if (event.target.classList.contains('geSwitcher--Btn')) return
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    closeAnimation(detailsElement);
  }

}

customElements.define('menu-drawer', MenuDrawer);

// Remove every `inert` this drawer added, found by attribute rather than by
// re-walking the tree — the page must never be left inert (and so unreachable
// to both Tab and the VoiceOver cursor) if the DOM changed while it was open.
const clearDrawerInert = () => {
  document.querySelectorAll('[data-drawer-inert]').forEach((el) => {
    el.removeAttribute('inert');
    el.removeAttribute('data-drawer-inert');
  });
};

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  // Toggle `inert` on everything except this drawer while it's open, so the
  // screen-reader cursor and Tab focus are confined to the drawer. Walk up to
  // <body>, inerting siblings at each level; only clear inert from nodes we set
  // (so pre-existing inert elsewhere is left untouched).
  setPageInert(inert) {
    if (!inert) {
      clearDrawerInert();
      return;
    }

    let node = this;
    while (node && node !== document.body && node.parentElement) {
      for (const sibling of node.parentElement.children) {
        if (sibling === node) continue;
        if (!sibling.hasAttribute('inert')) {
          sibling.setAttribute('inert', '');
          sibling.setAttribute('data-drawer-inert', '');
        }
      }
      node = node.parentElement;
    }
  }

  // Move focus INTO the drawer, which is what makes the VoiceOver cursor enter
  // the labelled role="dialog" instead of staying parked on the hamburger.
  //
  // Two things make a single, immediate focus() call useless here:
  //
  // 1. `open` is not on the <details> yet. Toggling it is the *default action*
  //    of the summary click, so it lands after this handler returns — which is
  //    also why `menu-opening` below is deferred with setTimeout.
  // 2. The drawer opens from `visibility: hidden` and translateX(100%), and
  //    focus() on a hidden element is a silent no-op, so anything attempted
  //    before the open transition has painted does nothing.
  //
  // So poll, and use "focus actually landed" — read back off
  // document.activeElement — as the exit condition rather than trying to
  // predict when the drawer became focusable. Cancelled by closeMenuDrawer.
  focusDrawer() {
    const drawer = this.querySelector('#menu-drawer');
    if (!drawer) return;

    this.cancelDrawerFocus();

    const deadline = Date.now() + 2000;

    // Land on the drawer's Close control (a leaf control), NOT the #menu-drawer
    // container. Focusing the labelled role="dialog" container makes VoiceOver
    // announce the dialog and read into it, and then the next Tab lands on the
    // first control *inside* and re-announces the same boundary — two stops
    // saying nearly the same thing. Landing on a control collapses that to one:
    // VoiceOver still says "Menu, dialog" as focus crosses in, then "Close,
    // button". Same reasoning as the fit-guide modal in pdp-section.js.
    const focusTarget = drawer.querySelector('.header__icon--close') || drawer;

    const tryFocus = () => {
      if (drawer.contains(document.activeElement)) return; // landed
      if (Date.now() >= deadline) return;

      if (this.mainDetailsToggle.hasAttribute('open')) focusTarget.focus();

      // On a timer rather than requestAnimationFrame: rAF is throttled or
      // frozen exactly when the drawer is slow to paint, which is when the
      // retry matters. A landed focus still gets one follow-up check, because
      // iOS VoiceOver sometimes bounces focus back to the element just tapped.
      this.drawerFocusTimer = setTimeout(tryFocus, document.activeElement === focusTarget ? 100 : 50);
    };

    tryFocus();
  }

  cancelDrawerFocus() {
    clearTimeout(this.drawerFocusTimer);
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    // Make everything outside the drawer inert. This is what actually bounds the
    // VoiceOver swipe cursor — a Tab trap only constrains keyboard focus.
    this.setPageInert(true);
    this.focusDrawer();
  }

  closeMenuDrawer(event, elementToFocus) {
    if (event === undefined) return;

    this.cancelDrawerFocus();
    this.setPageInert(false);
    super.closeMenuDrawer(event, elementToFocus);
    this.header?.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false),
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems)
      .filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1]
      .offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage !== previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1],
        },
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      (element.offsetLeft + element.clientWidth) <= 
      lastVisibleSlide && 
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = (
        this.slider.scrollLeft + 
        this.sliderFirstItemNode.clientWidth * 
        this.sliderItemsToShow.length
      );
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = (
      event.target === this.sliderAutoplayButton || 
      this.sliderAutoplayButton.contains(event.target)
    );
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = (
      event.target === this.sliderAutoplayButton || 
      this.sliderAutoplayButton.contains(event.target)
    );
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = (
      this.slider.scrollLeft + 
      this.sliderFirstItemNode.clientWidth * 
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - 
      this.currentPage)
    );
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData()
      .find((variant) => !variant.options)
      .map((option, index) => this.options[index] === option)
      .includes(false);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = (
      this.variantData || 
      JSON.parse(this.querySelector('[type="application/json"]')?.textContent)
    );
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
  }
}

customElements.define('variant-radios', VariantRadios);

document.querySelectorAll('[data-smooth-scroll]').forEach((anchor) => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    targetElement.scrollIntoView({
      behavior: 'smooth'
    });
  });
});

const faqBlocks = function () {
  const faqWraper = document.querySelector('.footer__blocks-wrapper');
  const footerBlocks = faqWraper.querySelectorAll('.footer-block');
  const buttonBlocks = faqWraper.querySelectorAll('.footer-block .Icon');
  faqWraper.addEventListener('click', (e) => {
    const wrapperBlock = e.target.closest('.footer-block');
    const countryPicker = e.target.closest('.geSwitcher--Btn');
    if (!wrapperBlock || countryPicker ) return
    const buttonBlock = wrapperBlock.querySelector('.Icon');
    const blockOpen = wrapperBlock.classList.contains("open")

    footerBlocks.forEach(b => {
      b.classList.remove('open')
    })
    buttonBlocks.forEach(b => {
      b.setAttribute('aria-expanded', 'false')
    })

    blockOpen ? wrapperBlock.classList.remove('open') : wrapperBlock.classList.add('open')
    buttonBlock.setAttribute('aria-expanded', !blockOpen);
  });
};

faqBlocks();

const addMegaMenuToggler = function () {
  const body = document.querySelector('body')
  const scrollBarWidth = window.outerWidth - body.getBoundingClientRect().width
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`)
  const stickyHeader = document.querySelector('sticky-header');
  const sectionHeader = document.querySelector('.section-header');
  const header = document.querySelector('.header');
  const headerWrapper = document.querySelector('.header-wrapper');
  const megaMenus = document.querySelectorAll('.mega-menu__content')
  const titles = document.querySelectorAll('.mega-menu a.list-menu__item')
  header.addEventListener('mouseover', (e) => {
    const listItem = e.target.closest('.mega-menu'); // selecing menu item
    if (listItem) { // checking if the hover is over a menu item
      const itemTitle = listItem.querySelector('a.list-menu__item')
      megaMenus.forEach(m => {
        m.classList.remove('mega-menu__content-open')
      })
      titles.forEach(t => {
        t.classList.remove('menu-open')
      })
      listItem.querySelector('.mega-menu__content').classList.add('mega-menu__content-open');
      stickyHeader.classList.add('overlay')
      sectionHeader.classList.add('mega-menu-open')
      itemTitle.classList.add('menu-open')
      headerWrapper.style.borderColor = '#ddd';
      let imgs = listItem.querySelectorAll('.mega-menu__content .mega-menu__push-img');
      imgs.forEach(img => {
        let src = img.getAttribute('data-src')
        if (src) {
          img.setAttribute("src", src) // lazyload image
          img.removeAttribute('data-src')
        }
      })

      let videos = listItem.querySelectorAll('.mega-menu__content .push-container video')
      videos.forEach(video => {
        let videoSrc = video.getAttribute('data-src')
        if (videoSrc) {
          video.setAttribute('src', videoSrc) // lazyload video
          video.removeAttribute('data-src')
        }
      })
    }
  });

  header.addEventListener('mouseout', (e) => {
    const listItem = e.target.closest('.mega-menu'); // selecting menu item
    if (listItem) {
      const itemTitle = listItem.querySelector('a.list-menu__item')
      itemTitle.classList.remove('menu-open')
    }
    if (listItem && e.relatedTarget !== header) { // checking if mouse left for another menu item
      listItem.querySelector('.mega-menu__content').classList.remove('mega-menu__content-open');
      stickyHeader.classList.remove('overlay')
      sectionHeader.classList.remove('mega-menu-open')
      headerWrapper.style.borderColor = 'transparent';
    }
    if (e.target === header) { // checking if mouse left header
      header.querySelectorAll(".mega-menu").forEach((menu) => { // closing all open mega menus
        menu.querySelector('.mega-menu__content').classList.remove('mega-menu__content-open');
        stickyHeader.classList.remove('overlay')
        sectionHeader.classList.remove('mega-menu-open')
        headerWrapper.style.borderColor = 'transparent';
      });
    }
  });
};

addMegaMenuToggler();

const invalidEmailMessage = function() {
  const emailInput = document.querySelector('.newsletter-form__field-wrapper input[id^="NewsletterForm--"]');
  const invalidMessage = document.querySelector('.newsletter-form__field-wrapper input[id^="NewsletterForm--"] ~ .invalid-email-message');

  emailInput.addEventListener("invalid", e => {
    e.preventDefault();
    invalidMessage.classList.add('invalid')
  })

  emailInput.addEventListener('input', e => {
    invalidMessage.classList.remove('invalid')
  })
}

invalidEmailMessage()

function closeAnimation(detailsElement) {
  let animationStart;

  const handleAnimation = (time) => {
    if (animationStart === undefined) {
      animationStart = time;
    }

    const elapsedTime = time - animationStart;

    if (elapsedTime < 400) {
      window.requestAnimationFrame(handleAnimation);
    } else {
      detailsElement.removeAttribute('open');
      if (detailsElement.closest('details[open]')) {
        trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
      }
    }
  };

  window.requestAnimationFrame(handleAnimation);
}

// The drawer's own close button. Delegate to <header-drawer> instead of
// re-implementing the teardown: only that method clears the page-wide `inert`,
// and duplicating it here is what used to leave the whole page inert — and so
// invisible to VoiceOver and untabbable — after the drawer was closed.
const closeMenuDrawer = function (event) {
  const headerDrawer = document.querySelector('header-drawer');
  const summary = document.querySelector('#Details-menu-drawer-container > summary');
  if (!headerDrawer) return;

  summary?.setAttribute('aria-expanded', 'false');
  headerDrawer.closeMenuDrawer(event, summary);
};

document.querySelectorAll('.header__icon.header__icon--close').forEach((btn) => {
  btn.addEventListener('click', closeMenuDrawer);
  // The button is a <span role="button"> — a <button> would be picked up by
  // MenuDrawer.bindEvents() as a submenu back-button — so Enter/Space have to
  // be wired up by hand.
  btn.addEventListener('keydown', (event) => {
    if (!['Enter', ' ', 'Spacebar'].includes(event.key)) return;
    event.preventDefault();
    closeMenuDrawer(event);
  });
});

const onGorgiasLoad = () => {
  const timer = setInterval(function () {
    const chatButtonIframe = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button')?.contentWindow
    const chatButtonHead = chatButtonIframe?.document.querySelector('head');
    if (!chatButtonHead || ![...chatButtonHead?.children].some(x => x.getAttribute("data-emotion"))) {
        return;
    }
    clearInterval(timer);

    const buttonStyle = document.createElement('style');
    buttonStyle.textContent = `
    .messenger-button-iframe-149xenf svg {display: none} 
    .messenger-button-iframe-149xenf {
      background-image: url("//cdn.shopify.com/s/files/1/0021/9063/9187/files/2022_FAVICON.svg?v=1683281791")
    }`;
    chatButtonHead.appendChild(buttonStyle);
}, 50);

}
window.addEventListener('gorgias-widget-loaded', onGorgiasLoad)

